import { message } from "antd";
import React, { createContext, useState, useContext, } from "react";


const AuthContext = createContext();


export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};


export const AuthProvider = ({ children }) => {

    const [token, setToken] = useState(
        localStorage.getItem("token") || sessionStorage.getItem("token")
    );

    const [isLocked, setIsLocked] = useState(() => {
        const stored = localStorage.getItem("isLocked");
        return stored ? JSON.parse(stored) : false;
    });

    const [role, setRole] = useState(null);

    const [userType, setUserType] = useState(() =>
        localStorage.getItem("userType") || "Admin"
    );


    const [loggedUser, setLoggedUser] = useState(JSON.parse(
        localStorage.getItem("isLoggedUser")
    ) || [])

    const [user, setUser] = useState(
        JSON.parse(localStorage.getItem("user")) || null
    );


    const getLockedAction = (lock) => {
        setIsLocked(lock);
        localStorage.setItem("isLocked", JSON.stringify(lock));
    };

    const getStaffRole = (role) => {
        setRole(role);
    };

    const getUserType = (types) => {
        setUserType(types);
        localStorage.setItem("userType", types);
    };

    const getCurrentUser = (newUser) => {
        setUser(newUser);
        localStorage.setItem("user", JSON.stringify(newUser));
    };

    const login = (newToken, rememberMe) => {
        setToken(newToken);
        if (rememberMe) {
            localStorage.setItem("token", newToken);
        } else {
            sessionStorage.setItem("token", newToken);
        }
    };


    const logoutStaffParent = (userId) => {
        setToken(null);
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("selectedChildId");
        message.error("You are logged out!");
        setIsLocked(false)
    };

    // const logout = (userId) => {
    //     setToken(null);
    //     localStorage.removeItem("token");
    //     sessionStorage.removeItem("token");
    //     localStorage.removeItem("user");
    //     localStorage.removeItem("selectedChildId");
    //     removeLoggedUser(userId);
    //     message.error("You are logged out!");
    //     setIsLocked(false)
    // };

    const logout = (userId) => {

    // ✅ remove logout daycare
    const updatedUsers = loggedUser.filter(
        (u) => u.daycareId !== userId
    );

    // ✅ update state immediately
    setLoggedUser(updatedUsers);

    // ✅ store updated array
    localStorage.setItem(
        "isLoggedUser",
        JSON.stringify(updatedUsers)
    );


    if (updatedUsers.length > 0) {

        const nextUser = updatedUsers[0];

        // active daycare
        const updatedLogged = updatedUsers.map((u) => ({
            ...u,
            isLogged: u.daycareId === nextUser.daycareId,
        }));

        // update states
        setLoggedUser(updatedLogged);
        setToken(nextUser.token);
        setUser(nextUser);

        // storage update
        localStorage.setItem(
            "isLoggedUser",
            JSON.stringify(updatedLogged)
        );

        localStorage.setItem("token", nextUser.token);

        localStorage.setItem(
            "user",
            JSON.stringify(nextUser)
        );

        message.success("Switched to another daycare");

    } else {
        setToken(null);
        setUser(null);
        setLoggedUser([]);

        localStorage.clear();
        sessionStorage.clear();

        message.success("Logged out");

        window.location.href = "/login";
    }
};

    // ✅ Logout All
    const logoutAllDaycare = () => {
        setToken(null);
        setUser(null);
        setLoggedUser([]);

        localStorage.clear();
        sessionStorage.clear();

        message.success("All daycare logged out");

        window.location.href = "/login";
    };

    const getIsLoggedUser = (user) => {
        setLoggedUser((prev) => {

            let updated = prev.map((u) => ({
                ...u,
                isLogged: false,
            }));
            const index = updated.findIndex(
                (u) => u.daycareId === user.daycareId
            );

            if (index !== -1) {

                updated[index] = {
                    ...updated[index],
                    ...user,
                    isLogged: true,
                };
            } else {

                updated.push({
                    ...user,
                    isLogged: true,
                });
            }
            localStorage.setItem("isLoggedUser", JSON.stringify(updated));
            return updated;
        });
    };

    const removeLoggedUser = (userId) => {
        setLoggedUser((prev) => {
            const updated = prev.filter((u) => u._id !== userId);
            localStorage.setItem("isLoggedUser", JSON.stringify(updated));
            return updated;
        });
    };


    return (
        <AuthContext.Provider value={{
            token, login, setToken, logout, getCurrentUser, user,
            loggedUser, getIsLoggedUser, getUserType, userType,
            isLocked, getLockedAction, getStaffRole, role,
            logoutStaffParent,logoutAllDaycare 
        }}>
            {children}
        </AuthContext.Provider>
    );
};
